export type ActivityPeriod = 'today' | '7d' | 'month' | 'year';

export type ActivityKind = 'replay' | 'puzzles' | 'srs';

export type ActivityPeriodCounts = Record<ActivityPeriod, number>;

export type ActivitySummaryResponse = {
  replay: ActivityPeriodCounts;
  puzzles: ActivityPeriodCounts;
  srs: ActivityPeriodCounts;
  puzzle_elo: number;
};

export type ActivityInteraction = {
  id: string;
  occurredAt: string;
  label: string;
  detail?: string;
  gameId?: string;
  puzzleId?: string;
  cardId?: string;
  lineId?: string;
};

export type ActivityDetailsResponse = {
  kind: ActivityKind;
  period: ActivityPeriod | 'all';
  total: number;
  interactions: ActivityInteraction[];
  limit: number;
  offset: number;
  hasMore: boolean;
};

export const ACTIVITY_KIND_LABELS: Record<ActivityKind, string> = {
  replay: 'Games replayed',
  puzzles: 'Puzzles completed',
  srs: 'SRS cards reviewed',
};

export const ACTIVITY_PERIOD_LABELS: Record<ActivityPeriod | 'all', string> = {
  today: 'Today',
  '7d': 'Last 7 days',
  month: 'This month',
  year: 'This year',
  all: 'All time',
};

export const ACTIVITY_PERIODS: ActivityPeriod[] = [
  'today',
  '7d',
  'month',
  'year',
];

export const isActivityKind = (value: string): value is ActivityKind =>
  value === 'replay' || value === 'puzzles' || value === 'srs';

export const isActivityPeriod = (
  value: string | null,
): value is ActivityPeriod | 'all' =>
  value === 'today' ||
  value === '7d' ||
  value === 'month' ||
  value === 'year' ||
  value === 'all';
